/** @todo: currency symbol must come from config */
export const CURRENCY_SYMBOL = "€"
/** @todo: unit must come from config */
export const UNIT_OF_MASS = "kg"
/** @todo: unit must come from config */
export const UNIT_OF_LARGE_MASS = "to"
/** @todo: must match UNIT_OF_MASS / UNIT_OF_LARGE_MASS from config */
const UNITS_OF_MASS_PER_LARGE_MASS = 1000

/**
 * Prices are stored and transferred per kg (`price_per_kg`), but
 * entered and displayed per UNIT_OF_LARGE_MASS.
 * Rounded to hide floating point artifacts (e.g. 1.005 * 1000).
 */
export const pricePerKgToPerLargeMass = (pricePerKg: number): number =>
  Number((pricePerKg * UNITS_OF_MASS_PER_LARGE_MASS).toFixed(6))

/** Inverse of {@link pricePerKgToPerLargeMass}. */
export const pricePerLargeMassToPerKg = (pricePerLargeMass: number): number =>
  Number((pricePerLargeMass / UNITS_OF_MASS_PER_LARGE_MASS).toFixed(9))

export const STATS_greenAnnotationHalfWidth = 3
export const STATS_yellowAnnotationHalfWidth = 1.5
